import { render, staticRenderFns } from "./LightningSor.vue?vue&type=template&id=12563eb8"
import script from "./LightningSor.vue?vue&type=script&lang=js"
export * from "./LightningSor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports